import Header from 'components/Headers/Header';
import React, { useEffect, useMemo, useState } from 'react';
import { useTable, useGlobalFilter } from 'react-table';
import { Card, Table, Container, Row } from 'reactstrap';
import { GlobalFilter } from 'components/Generic/GlobalFilter';
import { handleSendGeneric } from 'services/generic';
import { convertBrl } from 'utility/generic';
import CardStatics from 'components/Card/Card';
import { convertToFloatBr } from 'utility/generic';
import { SelectWihoutControl } from 'components/Form/Fields';
import { TYPE_FILTER } from 'utility/data-offiline';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { DeleteWithModalButton } from 'components/Table/ActionTable';
import _ from 'lodash';

export function TableGeneric({
  columns,
  data,
  reportData,
  reportFilter,
  setReportFilter,
  dateFilter,
  setDateFilter,
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
  );

  const { globalFilter } = state;
  const history = useHistory();

  const handleChangeDataReport = (e) => {
    const select = e.target.value;
    setReportFilter(select);
    if (select === 'Pagamentos') {
      return;
    }

    setTimeout(() => history.push('/admin/report'), 200);
  };

  return (
    <>
      <div style={{ marginTop: '12px' }}>
        <CardStatics name={'Saldo Total'}>
          {convertBrl(
            data.reduce(
              (a, b) =>
                convertToFloatBr(a) +
                convertToFloatBr(
                  b?.amount_paid === undefined ? 0 : b.amount_paid,
                ),
              0,
            ),
          )}
        </CardStatics>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <GlobalFilter
          filter={globalFilter}
          setFilter={setGlobalFilter}
          disableButtomCreate={true}
        />
        <input
          type='date'
          value={dateFilter}
          onChange={(e) => setDateFilter(e.target.value)}
          style={{
            height: '38px',
            border: '1px solid #ced4da',
            borderRadius: '4px',
            padding: '0 8px',
            fontSize: '14px',
          }}
        />
        {dateFilter && (
          <button
            onClick={() => setDateFilter('')}
            style={{
              height: '38px',
              padding: '0 10px',
              border: '1px solid #ced4da',
              borderRadius: '4px',
              background: '#f8f9fa',
              cursor: 'pointer',
              fontSize: '13px',
            }}
          >
            Todos
          </button>
        )}
        <SelectWihoutControl
          label={''}
          size={2}
          data={TYPE_FILTER}
          onChange={handleChangeDataReport}
          value={reportFilter}
        />
      </div>

      <Table responsive striped hover {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  scope='col'
                  {...column.getHeaderProps()}
                  style={{ fontSize: '18px' }}
                >
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.length > 0 ? (
            rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} id={i}>
                  {row.cells.map((cell, i) => {
                    return (
                      <td
                        id={i}
                        {...cell.getCellProps()}
                        style={{ fontSize: '18px' }}
                      >
                        {cell.render('Cell')}
                      </td>
                    );
                  })}
                </tr>
              );
            })
          ) : (
            <tr>
              <td
                colSpan='7'
                style={{ textAlign: 'center', width: '20px', fontSize: '18px' }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '14px',
                    alignItems: 'center',
                  }}
                >
                  Nenhum registro para mostrar!
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
}

const getDatePart = (dateStr) => {
  if (!dateStr) return '';
  // ISO: 2024-01-15T14:30:00
  if (dateStr.includes('-')) return dateStr.substring(0, 10);
  // Brazilian: 15/01/2024 or 15/01/2024 14:30
  const [datePart] = dateStr.split(' ');
  const [day, month, year] = datePart.split('/');
  return `${year}-${month}-${day}`;
};

export const ReportPaymentList = () => {
  const [report, setReport] = useState([]);
  const [reportFilter, setReportFilter] = useState('Pagamentos');
  const [dateFilter, setDateFilter] = useState('');

  useEffect(() => {
    async function getAllPayment() {
      const data = await handleSendGeneric(`/v1/client/payment`, 'GET');
      if (data !== undefined) {
        const sortedByNewestDate = _.orderBy(data, ['lastUpdate'], ['desc']);
        setReport(sortedByNewestDate);
      }
    }

    getAllPayment();
  }, []);

  const cacheItemsDisabled = React.useMemo(() => {
    if (!dateFilter) return report;
    return report.filter((item) => {
      const dateStr = item.executedAt || item.lastUpdate;
      return getDatePart(dateStr) === dateFilter;
    });
  }, [report, dateFilter]);

  const columns = useMemo(
    () => [
      {
        Header: 'Pago em',
        Cell: ({ ...props }) => {
          const { executedAt, lastUpdate } = props.data[props.row.index];
          return <span>{executedAt || lastUpdate}</span>;
        },
      },
      {
        Header: 'Razão Social',
        accessor: 'client.name',
      },
      {
        Header: 'Cidade',
        accessor: 'client.city',
      },
      {
        Header: 'Pago',
        Cell: ({ ...props }) => {
          const { amount_paid } = props.data[props.row.index];
          return <span>{amount_paid}</span>;
        },
      },
      {
        Header: 'Ação',
        Cell: ({ ...props }) => {
          const actionId = props.data[props.row.index]?.id;
          return (
            <DeleteWithModalButton
              urlDelete={'/v1/client/payment/'}
              idDelete={actionId}
              listUpdate={setReport}
            />
          );
        },
      },
    ],
    [],
  );

  return (
    <>
      <Header />
      <Container className='mt--7' fluid>
        <Row>
          <div className='col'>
            <Card className='shadow'>
              <TableGeneric
                columns={columns}
                data={cacheItemsDisabled}
                reportData={report}
                setReportData={setReport}
                rawData={[]}
                reportFilter={reportFilter}
                setReportFilter={setReportFilter}
                dateFilter={dateFilter}
                setDateFilter={setDateFilter}
              />
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};
